/* DogAtEase buy box — subscribe-first tiers, one-time fallback with a refill add-on */
(function () {
  'use strict';

  var form = document.getElementById('buyForm');
  if (!form) return;

  var tierInputs  = [].slice.call(form.querySelectorAll('input[name="tier"]'));
  var addonWrap   = form.querySelector('[data-addon]');
  var addonInput  = addonWrap ? addonWrap.querySelector('input[name="addon"]') : null;
  var addonNow    = form.querySelector('[data-addon-now]');
  var addonWas    = form.querySelector('[data-addon-was]');
  var totalOut    = form.querySelector('[data-total]');
  var saveOut     = form.querySelector('[data-save]');
  var renewalOut  = form.querySelector('[data-renewal]');
  var hiddenId    = form.querySelector('input[name="id"]');
  var planField   = form.querySelector('[data-plan-field]');
  var submitBtn   = form.querySelector('[data-submit]');
  var toggleBtn   = form.querySelector('[data-mode-toggle]');
  var modeEls     = [].slice.call(form.querySelectorAll('[data-when]'));

  var sticky      = document.querySelector('[data-stickybar]');
  var stickyAmt   = sticky ? sticky.querySelector('[data-sticky-amt]') : null;

  var moneyFormat = form.getAttribute('data-money-format') || '${{amount}}';
  var hasPlans    = form.getAttribute('data-has-plans') === 'true';

  var refillVid     = Number(form.getAttribute('data-refill-vid') || 0);
  var refillPrice   = Number(form.getAttribute('data-refill-price') || 0);
  var refillCompare = Number(form.getAttribute('data-refill-compare') || 0);
  var refillSub     = Number(form.getAttribute('data-refill-sub') || 0);

  var LABEL_ONCE = form.getAttribute('data-label-once') || '';
  var LABEL_SUB  = form.getAttribute('data-label-sub')  || '';
  var RENEWAL    = form.getAttribute('data-renewal-note') || '';

  // 'sub' = subscribe and save, refills auto-ship. 'once' = pay once, refills are a tick-box.
  var mode = hasPlans ? 'sub' : 'once';
  var addonOn = true;   // the one-time refill box is pre-selected

  function money(cents) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    v = parts.join('.');
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/, v)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0]);
  }

  function num(el, attr) { return parseInt(el.getAttribute(attr) || '0', 10) || 0; }

  function currentTier() {
    for (var i = 0; i < tierInputs.length; i++) if (tierInputs[i].checked) return tierInputs[i];
    return tierInputs[0];
  }

  function tierPrice(inp) { return mode === 'sub' ? num(inp, 'data-sub') : num(inp, 'data-price'); }
  function tierWas(inp)   { return mode === 'sub' ? num(inp, 'data-price') : num(inp, 'data-compare'); }

  function render() {
    var t = currentTier();
    if (!t) return;

    // show only the rows that belong to this mode
    modeEls.forEach(function (el) {
      var when = el.getAttribute('data-when');
      el.hidden = !(when === 'both' || when === mode);
    });

    tierInputs.forEach(function (inp) {
      var card = inp.closest('.tier');
      if (card) card.classList.toggle('is-on', inp.checked);

      var now  = card && card.querySelector('[data-tier-now]');
      var was  = card && card.querySelector('[data-tier-was]');
      var unit = card && card.querySelector('[data-tier-unit]');
      var price = tierPrice(inp), wasPrice = tierWas(inp);
      var units = num(inp, 'data-units') || 1;

      if (now) now.textContent = money(price);
      if (was) was.textContent = wasPrice > price ? money(wasPrice) : '';
      if (unit) {
        unit.textContent = money(Math.round(price / units)) + ' each' +
          (units > 1 ? ' · covers ' + units + ' rooms' : '');
      }
    });

    if (hiddenId)  hiddenId.value  = t.getAttribute('data-vid') || '';
    if (planField) planField.value = (mode === 'sub') ? (t.getAttribute('data-plan') || '') : '';

    var total   = tierPrice(t);
    var compare = tierWas(t) || total;

    if (addonWrap) {
      addonWrap.classList.toggle('is-on', addonOn);
      if (addonInput) addonInput.checked = addonOn;
      if (addonNow) addonNow.textContent = money(refillPrice);
      if (addonWas) addonWas.textContent = refillCompare > refillPrice ? money(refillCompare) : '';
      if (mode === 'once' && addonOn) {
        total   += refillPrice;
        compare += refillCompare || refillPrice;
      }
    }

    if (totalOut)  totalOut.textContent  = money(total);
    if (stickyAmt) stickyAmt.textContent = money(total);
    if (saveOut) {
      var diff = compare - total;
      saveOut.textContent = diff > 0 ? ('You save ' + money(diff)) : '';
    }

    if (toggleBtn) {
      toggleBtn.textContent = mode === 'sub' ? LABEL_ONCE : LABEL_SUB;
    }

    if (renewalOut) {
      if (mode === 'sub' && RENEWAL) {
        renewalOut.hidden = false;
        renewalOut.textContent = RENEWAL.replace('[refill]', money(refillSub || refillPrice));
      } else {
        renewalOut.hidden = true;
        renewalOut.textContent = '';
      }
    }
  }

  tierInputs.forEach(function (inp) { inp.addEventListener('change', render); });

  if (addonInput) {
    addonInput.addEventListener('change', function () { addonOn = addonInput.checked; render(); });
  }

  if (toggleBtn) {
    toggleBtn.addEventListener('click', function (e) {
      e.preventDefault();
      mode = mode === 'sub' ? 'once' : 'sub';
      if (mode === 'once') addonOn = true;   // the box comes back pre-selected every time
      render();
    });
  }

  function buildItems() {
    var t = currentTier();
    var line = { id: Number(t.getAttribute('data-vid')), quantity: 1 };
    if (mode === 'sub') {
      var plan = t.getAttribute('data-plan');
      if (plan) line.selling_plan = Number(plan);
    }
    var items = [line];
    if (mode === 'once' && addonOn && refillVid) {
      items.push({ id: refillVid, quantity: 1 });
    }
    return items;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (submitBtn) submitBtn.setAttribute('aria-busy', 'true');
    var body = { items: buildItems() };
    fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        });
      })
      .then(function (r) { if (!r.ok) throw 0; window.location.href = '/checkout'; })
      .catch(function () { form.submit(); });
  });

  // every CTA on the page points at #buy — land them all on the buy card itself,
  // clear of the sticky nav, rather than on the top edge of the band.
  function toOffer(e) {
    var card = document.querySelector('.buy-card') || document.getElementById('buy');
    if (!card) return;
    if (e) e.preventDefault();
    var nav  = document.querySelector('.nav');
    var pad  = (nav ? nav.getBoundingClientRect().height : 70) + 16;
    var r    = card.getBoundingClientRect();
    var room = window.innerHeight - pad;
    var top  = window.scrollY + r.top - pad;
    if (r.height < room) top -= (room - r.height) / 2;
    window.scrollTo({ top: Math.max(0, Math.round(top)), behavior: 'smooth' });
    if (history.replaceState) history.replaceState(null, '', '#buy');
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href$="#buy"],a[href="#buy"],[data-sticky-btn]') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href && href.indexOf('#buy') === -1 && !a.hasAttribute('data-sticky-btn')) return;
    toOffer(e);
  });

  if (window.location.hash === '#buy') {
    window.setTimeout(function () { toOffer(null); }, 60);
  }

  if (sticky && 'IntersectionObserver' in window) {
    var card = document.querySelector('.buy-card');
    if (card) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-up', !entries[0].isIntersecting);
      }, { threshold: 0 }).observe(card);
    }
  }

  render();
})();

/* ---- benefit carousel: drag + auto-scroll, same mechanics as the lander ---- */
(function () {
  var box = document.getElementById('rvCarousel');
  var track = document.getElementById('rvTrack');
  if (!box || !track) return;

  var half = 0, pos = 0, dragging = false, startX = 0, startPos = 0, moved = 0, raf;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function measure() { half = track.scrollWidth / 2; }
  function apply() { track.style.transform = 'translateX(' + pos + 'px)'; }
  function norm() { if (half) { while (pos <= -half) pos += half; while (pos > 0) pos -= half; } }

  function tick() {
    if (!dragging) { pos -= 0.35; norm(); apply(); }
    raf = requestAnimationFrame(tick);
  }

  function down(x) { dragging = true; startX = x; startPos = pos; moved = 0; box.classList.add('is-drag'); }
  function move(x) { if (!dragging) return; var d = x - startX; moved = Math.abs(d); pos = startPos + d; norm(); apply(); }
  function up() { dragging = false; box.classList.remove('is-drag'); }

  box.addEventListener('mousedown', function (e) { down(e.clientX); e.preventDefault(); });
  window.addEventListener('mousemove', function (e) { move(e.clientX); });
  window.addEventListener('mouseup', up);
  box.addEventListener('touchstart', function (e) { down(e.touches[0].clientX); }, { passive: true });
  box.addEventListener('touchmove', function (e) { move(e.touches[0].clientX); }, { passive: true });
  box.addEventListener('touchend', up);
  box.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);

  window.addEventListener('resize', measure);
  measure();
  if (!reduce) raf = requestAnimationFrame(tick);
})();
